import {
  Typography,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Table,
} from "@mui/material";
import theme from "../../../../theme";
import {
  BODY_SPACING,
  COMPONENT_SPACING,
  SPACING,
} from "../../../../utils/constants/designConstants";

const TABLE_HEADERS = ["Accreditations", "Description", "Applicability"];

export const AccreditationsTable = ({ accreditations }) => {
  if (!accreditations || accreditations.length === 0) {
    return (
      <Typography
        variant="body2"
        sx={{
          py: BODY_SPACING.ERROR_MESSAGE_SECTION_PADDING,
          mb: BODY_SPACING.ERROR_MESSAGE_SECTION_MARGIN_BOTTOM,
        }}
      >
        Accreditations aren't available at the moment.
      </Typography>
    );
  }
  try {
    return (
      <TableContainer
        component={Paper}
        variant="outlined"
        sx={{ border: "none", backgroundColor: "transparent" }}
      >
        <Table
          sx={{
            minWidth: COMPONENT_SPACING.MIN_TABLE_WIDTH,
            my: SPACING.HEADER_MARGIN_Y,
          }}
          stickyHeader
          aria-label="accreditations table"
          size="small"
        >
          <TableHead>
            <TableRow>
              {TABLE_HEADERS.map((header, cellIndex) => (
                <TableCell
                  key={cellIndex}
                  sx={{
                    backgroundColor: "secondary.lawnGreen",
                    color: "primary.white",
                    fontWeight: "bold",
                    zIndex: 1,
                    borderTopLeftRadius:
                      cellIndex === 0 ? theme.borderRadius.small : 0,
                    borderTopRightRadius:
                      cellIndex === TABLE_HEADERS.length - 1
                        ? theme.borderRadius.small
                        : 0,
                  }}
                >
                  {header}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {accreditations.map((item, index) => {
              const isAlternateRow = index % 2 === 1;
              return (
                <TableRow
                  key={index}
                  sx={{
                    backgroundColor: isAlternateRow
                      ? `${theme.palette.secondary.lawnGreen}0D` // 5% opacity
                      : "primary.white",
                    "& td, & th": {
                      border: 0,
                    },
                  }}
                >
                  {/* Accreditation */}
                  <TableCell>{item.Accreditation || "-"}</TableCell>

                  {/* Description */}
                  <TableCell>{item.Description || "-"}</TableCell>

                  {/* Applicability */}
                  <TableCell>{item.Applicability || "-"}</TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    );
  } catch (error) {
    console.error("Error rendering acreditations table:", error);
    return (
      <Typography
        variant="body2"
        color="error"
        sx={{ py: BODY_SPACING.ERROR_MESSAGE_SECTION_PADDING }}
      >
        Sorry, we couldn’t display accreditations at the moment.
      </Typography>
    );
  }
};
